import {
  Configuration as MsalBrowserConfiguration,
  LogLevel,
  PublicClientApplication as MsalBrowserPublicClientApplication,
} from '@azure/msal-browser';
import { getAppConstants } from '@/lib/getAppConstants';
import { isLocal } from '@/lib/isLocal';

function getMsalOIDCOptions(
  clientId: MsalBrowserConfiguration['auth']['clientId'],
): MsalBrowserConfiguration['auth']['OIDCOptions'] {
  return {
    defaultScopes: ['openid', 'profile', 'email', `${clientId}/.default`],
  };
}

const createMsalConfig = (): MsalBrowserConfiguration => {
  const {
    OPM_COCKPIT_ENTRA_AUTHORITY: authority,
    OPM_COCKPIT_ENTRA_CLIENT_ID: clientId,
  } = getAppConstants();
  const OIDCOptions = getMsalOIDCOptions(clientId);
  return {
    auth: {
      clientId, // This is the ONLY mandatory field that you need to supply.
      redirectUri: `${window.location.origin}/auth/spa/callback`, // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
      // postLogoutRedirectUri: 'http://localhost:3000/', // Indicates the page to navigate after logout.
      OIDCOptions,
      authority,
    },
    cache: {
      cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
      cacheRetentionDays: 5, // Used to specify the number of days cache entries written by previous versions of MSAL.js should be retained in the browser. Defaults to 5 days.
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          // Don't log if there is any PII or the stage is neither local nor dev
          if (containsPii || !(isLocal() || import.meta.env.DEV)) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              // eslint-disable-next-line no-console
              console.error(message);
              return;
            case LogLevel.Info:
              // eslint-disable-next-line no-console
              console.info(message);
              return;
            case LogLevel.Verbose:
              // eslint-disable-next-line no-console
              console.debug(message);
              return;
            case LogLevel.Warning:
              // eslint-disable-next-line no-console
              console.warn(message);
              return;
            default:
              return;
          }
        },
      },
    },
  };
};

export function createMsalBrowserPublicClientApplication(): MsalBrowserPublicClientApplication {
  const config: MsalBrowserConfiguration = createMsalConfig();
  return new MsalBrowserPublicClientApplication(config);
}
